// DEPENDENCIES
import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { useFormik } from "formik";
import _ from 'lodash';
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import "flatpickr/dist/themes/material_green.css";
import "filepond/dist/filepond.min.css";
// COMPONENTS
import { Form } from 'react-bootstrap';
import { Link } from "react-router-dom";
import InputMask from "react-input-mask";
import { ModalProgressBar } from "../../../_metronic/_partials/controls";
import SVG from "react-inlinesvg";
import Flatpickr from "react-flatpickr";
import { FilePond, registerPlugin } from "react-filepond";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
// CUSTOM COMPONENTS
import * as clientService from "../../../services/management/clientService";
import * as alert from "../../../redux/alertSnackBarRedux";
// SERVICES AND HELPERS
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import ClientRegisterValidator from '../../../helpers/validators/ClientRegisterValidator';
import { getInputClasses, convertJsonToFormData } from "../../../helpers/helper";

registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

const UserRegisterPage = (props) => {
    const { showAlert } = props;
    const [loading, setloading] = useState(false);
    const [clientRegisterError, setClientRegisterError] = useState("");
    const [uploadedFile, setUploadedFile] = useState([]);

    const initialValues = {
        accountNumber: '',
        name: '',
        primaryPhone: '',
        contactName: '',
        email: '',
        additionalEmails: '',
        phoneNumber: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        zipCode: '',
        isActive: true,
        duplicateAsLocation: true
    };

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: ClientRegisterValidator,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            registerClientHandler(values, setStatus, setSubmitting);
        },
        onReset: (values, { resetForm }) => {
            resetForm();
        },
    });

    const registerClientHandler = (values, setStatus, setSubmitting) => {
        setloading(true);
        values.address = {
            address1: values.address1,
            address2: values.address2,
            city: values.city,
            state: values.state,
            zipCode: values.zipCode
        }
        if (uploadedFile.length > 0)
            values.uploadedFile = uploadedFile[0].file;

        registerClient(values, setSubmitting);
    };

    const registerClient = (values, setSubmitting) => {
        clientService.saveClient(convertJsonToFormData(values)).then(res => {
            props.history.push('/management/clients');
            showAlert({ message: res.message, variant: 'success' });
        }).catch(ex => setClientRegisterError(ex.message))
            .finally(() => setloading(false), setSubmitting(false))
    }

    return (
        <form
            className="card card-custom card-stretch"
            onSubmit={formik.handleSubmit}
        >
            {loading && <ModalProgressBar />}
            <div className="card-header py-3">
                <div className="card-title align-items-start flex-column">
                    <h3 className="card-label font-weight-bolder text-dark">
                        Add Client
                    </h3>
                    <span className="text-muted font-weight-bold fz-xs mt-1">
                        Please fill out the form below. Fields marked as <code>*</code> are required.
                    </span>
                </div>
                <div className="card-toolbar">
                    <button
                        type="submit"
                        className={`btn btn-success mr-2`}
                        disabled={
                            formik.isSubmitting || (formik.touched && !formik.isValid)
                        }
                    >
                        Save Client
                        {formik.isSubmitting}
                    </button>
                    <Link
                        to="/management/clients"
                        className="btn btn-danger"
                    >
                        Cancel
                    </Link>
                </div>
            </div>
            <div className="form">
                <div className="card-body">
                    {
                        clientRegisterError ?
                            <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
                                <div className="alert-text font-weight-bold">
                                    {clientRegisterError}
                                </div>
                            </div>
                            : <></>
                    }
                    <div className="row">
                        <label className="col-xl-3"></label>
                        <div className="col-lg-9 col-xl-6">
                            <h5 className="mt-lg-10 mb-6 fz-md fw-700 c-primary">Client Info</h5>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">Company Logo</label>
                        <div className="col-lg-9 col-xl-6">
                            <FilePond
                                acceptedFileTypes={['image/*']}
                                labelIdle='Drag & Drop image or <span class="filepond--label-action">Browse</span>'
                                onupdatefiles={setUploadedFile}
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                            Business Name*
                        </label>
                        <div className="col-lg-9 col-xl-6">
                            <input
                                type="text"
                                placeholder="XYZ Company"
                                className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "name")}`}
                                name="name"
                                {...formik.getFieldProps("name")}
                            />
                            {formik.touched.name && formik.errors.name ? (
                                <div className="invalid-feedback">
                                    {formik.errors.name}
                                </div>
                            ) : null}
                        </div>
                    </div>
                    {/* <div className="form-group row">
                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                            Account Number
                        </label>
                        <div className="col-lg-9 col-xl-6">
                            <div className="input-group input-group-lg input-group-solid">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">
                                        <span className="svg-icon menu-icon"> <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Mail-at.svg")} /> </span>
                                    </span>
                                </div>
                                <input
                                    type="text"
                                    placeholder="0012345"
                                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "accountNumber")}`}
                                    name="accountNumber"
                                    {...formik.getFieldProps("accountNumber")}
                                />
                            </div>
                            {formik.touched.accountNumber && formik.errors.accountNumber ? (
                                <div className="invalid-feedback">
                                    {formik.errors.accountNumber}
                                </div>
                            ) : null}
                        </div>
                    </div> */}
                    <div className="form-group row">
                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                            Contact Name
                        </label>
                        <div className="col-lg-9 col-xl-6">
                            <div className="input-group input-group-lg input-group-solid">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">
                                        <span className="svg-icon menu-icon"> <SVG src={toAbsoluteUrl("/media/svg/icons/General/User.svg")} /> </span>
                                    </span>
                                </div>
                                <input
                                    type="text"
                                    placeholder="John Doe"
                                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "contactName")}`}
                                    name="contactName"
                                    {...formik.getFieldProps("contactName")}
                                />
                            </div>
                            {formik.touched.contactName && formik.errors.contactName ? (
                                <div className="invalid-feedback">
                                    {formik.errors.contactName}
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                            Primary Email Address
                        </label>
                        <div className="col-lg-9 col-xl-6">
                            <div className="input-group input-group-lg input-group-solid">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">
                                        <span className="svg-icon menu-icon"> <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Mail.svg")} /> </span>
                                    </span>
                                </div>
                                <input
                                    type="email"
                                    placeholder="Email"
                                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "email")}`}
                                    name="email"
                                    {...formik.getFieldProps("email")}
                                />
                            </div>
                            {formik.touched.email && formik.errors.email ? (
                                <div className="invalid-feedback display-block">
                                    {formik.errors.email}
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                            Additional Email Addresses
                        </label>
                        <div className="col-lg-9 col-xl-6">
                            <div className="input-group input-group-lg input-group-solid">
                                <Form.Control
                                    as="textarea"
                                    rows="2"
                                    type="additionalEmails"
                                    placeholder="Enter Additional Emails"
                                    className={`form-control form-control-lg form-control-solid`}
                                    name="additionalEmails"
                                    {...formik.getFieldProps("additionalEmails")}
                                />
                            </div>
                            <span class="form-text text-muted">Email addresses must be separated with commas</span>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                            Contact Phone
                        </label>
                        <div className="col-lg-9 col-xl-6">
                            <div className="input-group input-group-lg input-group-solid">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">
                                        <span className="svg-icon menu-icon"> <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Adress-book1.svg")} /> </span>
                                    </span>
                                </div>
                                <InputMask
                                    mask="(999) 999-9999"
                                    type="text"
                                    placeholder="(225)-000-0000"
                                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "primaryPhone")}`}
                                    name="primaryPhone"
                                    {...formik.getFieldProps("primaryPhone")}
                                />
                            </div>
                            {formik.touched.primaryPhone && formik.errors.primaryPhone ? (
                                <div className="invalid-feedback display-block">
                                    {formik.errors.primaryPhone}
                                </div>
                            ) : null}
                        </div>
                    </div>

                    <div className="form-group row">
                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                            Is Active?
                        </label>
                        <div className="col-lg-9 col-xl-6">
                            <div className="checkbox-list">
                                <label className="checkbox checkbox-primary">
                                    <input
                                        type="checkbox"
                                        name="admin"
                                        checked={formik.values.isActive}
                                        {...formik.getFieldProps("isActive")}
                                    />
                                    <span></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <label className="col-xl-3"></label>
                        <div className="col-lg-9 col-xl-6">
                            <h5 className="mt-lg-10 mb-6 fz-md fw-700 c-primary">Address Info</h5>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                            Address 1*
                        </label>
                        <div className="col-lg-9 col-xl-6">
                            <div className="input-group input-group-lg input-group-solid">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">
                                        <i className="fa fa-home"></i>
                                    </span>
                                </div>
                                <input
                                    type="text"
                                    placeholder="123 Second St."
                                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "address1")}`}
                                    name="address1"
                                    {...formik.getFieldProps("address1")}
                                />
                            </div>
                            {formik.touched.address1 && formik.errors.address1 ? (
                                <div className="invalid-feedback display-block">
                                    {formik.errors.address1}
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                            Address 2
                        </label>
                        <div className="col-lg-9 col-xl-6">
                            <div className="input-group input-group-lg input-group-solid">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">
                                        <i className="fa fa-building"></i>
                                    </span>
                                </div>
                                <input
                                    type="text"
                                    placeholder="Apt# 1"
                                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "address2")}`}
                                    name="address2"
                                    {...formik.getFieldProps("address2")}
                                />
                            </div>
                            {formik.touched.address2 && formik.errors.address2 ? (
                                <div className="invalid-feedback display-block">
                                    {formik.errors.address2}
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                            City*
                        </label>
                        <div className="col-lg-9 col-xl-6">
                            <div className="input-group input-group-lg input-group-solid">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">
                                        <i className="fa fa-city"></i>
                                    </span>
                                </div>
                                <input
                                    type="text"
                                    placeholder="Baton Rouge"
                                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "city")}`}
                                    name="city"
                                    {...formik.getFieldProps("city")}
                                />
                            </div>
                            {formik.touched.city && formik.errors.city ? (
                                <div className="invalid-feedback display-block">
                                    {formik.errors.city}
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                            State*
                        </label>
                        <div className="col-lg-9 col-xl-6">
                            <div className="input-group input-group-lg input-group-solid">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">
                                        <i className="fa fa-flag-usa"></i>
                                    </span>
                                </div>
                                <input
                                    type="text"
                                    placeholder="Louisiana"
                                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "state")}`}
                                    name="state"
                                    {...formik.getFieldProps("state")}
                                />
                            </div>
                            {formik.touched.state && formik.errors.state ? (
                                <div className="invalid-feedback display-block">
                                    {formik.errors.state}
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                            Zip Code*
                        </label>
                        <div className="col-lg-9 col-xl-6">
                            <div className="input-group input-group-lg input-group-solid">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">
                                        <i className="fa fa-location-arrow"></i>
                                    </span>
                                </div>
                                <input
                                    type="text"
                                    placeholder="70809"
                                    className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "zipCode")}`}
                                    name="zipCode"
                                    {...formik.getFieldProps("zipCode")}
                                />
                            </div>
                            {formik.touched.zipCode && formik.errors.zipCode ? (
                                <div className="invalid-feedback display-block">
                                    {formik.errors.zipCode}
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                            Duplicate as Location?
                        </label>
                        <div className="col-lg-9 col-xl-6">
                            <div className="checkbox-list">
                                <label className="checkbox checkbox-primary">
                                    <input
                                        type="checkbox"
                                        name="admin"
                                        checked={formik.values.duplicateAsLocation}
                                        {...formik.getFieldProps("duplicateAsLocation")}
                                    />
                                    <span></span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    )
}

export default connect(null, alert.actions)(UserRegisterPage);